<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          crud-name="Desvios de horário revisados"
          new-text="Novo desvio"
          :table="checkScheduleDeviationsTable"
          :columns="columns"
          :options="options"
          :custom-filters="customFilters"
          :end-point="endPoint"
          :enable-add="false"
          :enable-edit="false"
          :enable-delete="false"
          :enable-view="false"
          :data-form="dataForm"
          @setDateFilter="setDateFilter"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

function format(datetime) {
  return datetime ? moment(datetime).format('DD/MM/YYYY HH:mm:ss') : 'N/A'
}

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      checkScheduleDeviationsTable: 'checkScheduleDeviationsTable',
      dateFilter: '',
      customFilters: [
        {
          name: 'created_at',
          call: 'setDateFilter',
          type: 'calendar',
        },
      ],
      columns: [
        'id',
        'user_id',
        'reviewer_id',
        'decision',
        'original_punched_at',
        'adjusted_punched_at',
        'reviewed_at',
        'justification',
      ],
      tableData: [
        'id',
        'user_id',
        'reviewer_id',
        'decision',
        'original_punched_at',
        'adjusted_punched_at',
        'reviewed_at',
        'justification',
      ],
      options: {
        filterByColumn: true,
        filterable: [
          'check_id',
          'user_id',
          'reviewer_id',
          'decision',
        ],
        // Dropdown nativo (Aprovado/Reprovado) no filtro da coluna Decisão.
        listColumns: {
          decision: [
            { id: 'approved', text: 'Aprovado' },
            { id: 'rejected', text: 'Reprovado' },
          ],
        },
        // Setas de ordenação (^ / v) usando Font Awesome.
        sortIcon: {
          base: 'fas',
          is: 'fa-sort',
          up: 'fa-sort-up',
          down: 'fa-sort-down',
        },
        sortable: [
          'id',
          'check_id',
          'decision',
          'original_punched_at',
          'adjusted_punched_at',
          'reviewed_at',
        ],
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        texts: {
          filterPlaceholder: 'Selecione',
          selectStatusPlaceholder: 'Selecione',
        },
        headings: {
          id: 'ID',
          user_id: 'Colaborador',
          reviewer_id: 'Revisor',
          decision: 'Decisão',
          original_punched_at: 'Horário original',
          adjusted_punched_at: 'Horário ajustado',
          reviewed_at: 'Revisado em',
          justification: 'Justificativa',
        },
        requestFunction(data) {
          const requestData = {}
          const queryString = this.$parent.$parent.$parent.query(data.query)

          requestData.params = data
          requestData.params.query = ''
          requestData.params.with = ['check', 'check.user', 'reviewer']

          return axios.get(`${this.url}?${queryString}`, requestData).catch(
            error => {
              this.dispatch('error', error)
            },
          )
        },
        templates: {
          check_id(createElement, rowData) {
            return rowData && rowData.check_id ? rowData.check_id : 'N/A'
          },
          user_id(createElement, rowData) {
            if (
              rowData
              && rowData.check
              && rowData.check.user
              && rowData.check.user.name
            ) {
              return rowData.check.user.name
            }
            return 'N/A'
          },
          reviewer_id(createElement, rowData) {
            if (
              rowData
              && rowData.reviewer
              && rowData.reviewer.name
            ) {
              return rowData.reviewer.name
            }
            return 'N/A'
          },
          decision(createElement, rowData) {
            const approved = rowData && rowData.decision === 'approved'
            return createElement(
              'span',
              { class: approved ? 'badge badge-success' : 'badge badge-danger' },
              approved ? 'Aprovado' : 'Reprovado',
            )
          },
          original_punched_at(createElement, rowData) {
            return format(rowData.original_punched_at)
          },
          adjusted_punched_at(createElement, rowData) {
            // Aprovado mantém o horário original (sem ajuste).
            if (rowData && rowData.decision === 'approved') {
              return 'Horário mantido'
            }
            return format(rowData.adjusted_punched_at)
          },
          reviewed_at(createElement, rowData) {
            return format(rowData.reviewed_at)
          },
          justification(createElement, rowData) {
            return rowData && rowData.justification ? rowData.justification : '—'
          },
        },
      },
      endPoint: 'checkscheduledeviations/',
      dataForm: {},
    }
  },
  methods: {
    setDateFilter(value) {
      this.dateFilter = value || ''
    },
    query(queryFilters) {
      const columns = {
        check_id: 'check_id',
        user_id: 'user_name',
        reviewer_id: 'reviewer_name',
        decision: 'decision',
      }

      let filters = ''

      if (this.dateFilter) {
        // Filtra pela DATA da revisão (intervalo do dia escolhido) — o backend
        // aplica whereBetweenDate quando o valor de uma coluna datetime tem vírgula.
        const range = `${this.dateFilter},${this.dateFilter}`
        filters += `reviewed_at=${encodeURIComponent(range)}&`
      }

      $.each(queryFilters, (index, value) => {
        if (columns[index] && value !== null && value !== undefined && value !== '') {
          filters += `${columns[index]}=${encodeURIComponent(value)}&`
        }
      })

      return filters
    },
  },
}
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
